import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Footer: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <footer style={{
      padding: '40px 24px',
      textAlign: 'center',
      borderTop: '1px solid rgba(255, 255, 255, 0.1)',
      backgroundColor: 'rgba(0, 0, 0, 0.2)',
    }}>
      <div style={{
        maxWidth: '800px',
        margin: '0 auto',
      }}>
        <div style={{
          fontSize: '24px',
          fontWeight: '600',
          color: 'white',
          marginBottom: '16px',
          fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, sans-serif',
          letterSpacing: '-0.01em',
        }}>
          Allez-Hopp
        </div>
        <p style={{
          fontSize: '16px',
          color: 'rgba(255, 255, 255, 0.7)',
          marginBottom: '24px',
          fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, sans-serif',
        }}>
          {t('footer.tagline')}
        </p>
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '32px',
          flexWrap: 'wrap',
          marginBottom: '24px',
        }}>
          <button 
            onClick={() => navigate('/privacy')}
            style={{ 
              color: 'rgba(255, 255, 255, 0.7)', 
              textDecoration: 'none', 
              background: 'none', 
              border: 'none', 
              cursor: 'pointer',
              fontSize: '16px',
              fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, sans-serif',
              transition: 'color 0.3s ease',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = 'white';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = 'rgba(255, 255, 255, 0.7)';
            }}
          >
            {t('footer.privacy')}
          </button>
          <button 
            onClick={() => navigate('/terms')}
            style={{ 
              color: 'rgba(255, 255, 255, 0.7)', 
              textDecoration: 'none', 
              background: 'none', 
              border: 'none', 
              cursor: 'pointer',
              fontSize: '16px',
              fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, sans-serif',
              transition: 'color 0.3s ease',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = 'white';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = 'rgba(255, 255, 255, 0.7)';
            }}
          >
            {t('footer.terms')}
          </button>
          <button 
            onClick={() => navigate('/imprint')}
            style={{ 
              color: 'rgba(255, 255, 255, 0.7)', 
              textDecoration: 'none', 
              background: 'none', 
              border: 'none', 
              cursor: 'pointer',
              fontSize: '16px',
              fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, sans-serif',
              transition: 'color 0.3s ease',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = 'white';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = 'rgba(255, 255, 255, 0.7)';
            }}
          >
            {t('footer.imprint')}
          </button>
          <button 
            onClick={() => navigate('/support')}
            style={{ 
              color: 'rgba(255, 255, 255, 0.7)', 
              textDecoration: 'none', 
              background: 'none', 
              border: 'none', 
              cursor: 'pointer',
              fontSize: '16px',
              fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, sans-serif',
              transition: 'color 0.3s ease',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = 'white';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = 'rgba(255, 255, 255, 0.7)';
            }}
          >
            {t('footer.support')}
          </button>
        </div>
        <p style={{
          fontSize: '14px',
          color: 'rgba(255, 255, 255, 0.5)',
        }}>
          {t('footer.copyright')}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
